import { render } from "./thumbnail.vue?vue&type=template&id=18695c2a&ts=true"
import script from "./thumbnail.vue?vue&type=script&lang=ts"
export * from "./thumbnail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__